/**
 * Cherry LA - Redo Shopify Toggle Adapter
 * Converts <redo-shopify-toggle>'s closed shadow root into a single-button toggle system
 * styled identically to .cherry-cart__protection.
 */
(() => {
  const STORAGE_KEY = 'cherry_redo_protection_active';
  const subtotalPlacements = new Map();

  function restoreDetachedSubtotals() {
    subtotalPlacements.forEach(({ holder, marker, originalSlot }, host) => {
      if (host.isConnected && host.contains(holder)) return;
      if (marker.isConnected) {
        if (originalSlot === null) holder.removeAttribute('slot');
        else holder.setAttribute('slot', originalSlot);
        marker.replaceWith(holder);
      }
      subtotalPlacements.delete(host);
    });
  }

  const getSavedPreference = () => {
    try {
      const val = localStorage.getItem(STORAGE_KEY);
      return val === null ? true : val === 'true';
    } catch (e) {
      return true;
    }
  };

  const savePreference = (val) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(val));
    } catch (e) {}
  };

  const SHADOW_CSS = `
    [data-target="info-card-container"] {
      display: none !important;
    }

    .cherry-redo-toggle-row {
      display: grid !important;
      grid-template-columns: minmax(0, auto) 24px 1fr !important;
      gap: 10px !important;
      align-items: center !important;
      width: 100% !important;
      min-height: 54px !important;
      padding: 10px 0 !important;
      margin-bottom: 12px !important;
      border-bottom: 0.5px solid #e3e3e1 !important;
      box-sizing: border-box !important;
      font-family: inherit !important;
    }

    .cherry-redo-toggle-label {
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      min-width: 0 !important;
      margin: 0 !important;
      color: #241a12 !important;
      cursor: pointer !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
      letter-spacing: 0.7px !important;
      white-space: nowrap !important;
      user-select: none !important;
      -webkit-user-select: none !important;
    }

    .cherry-redo-toggle-input {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      opacity: 0 !important;
    }

    .cherry-redo-toggle-switch {
      position: relative !important;
      display: block !important;
      flex: 0 0 44px !important;
      width: 44px !important;
      height: 22px !important;
      background: #e3e3e1 !important;
      border-radius: 30px !important;
      transition: background-color 0.2s ease !important;
      cursor: pointer !important;
    }

    .cherry-redo-toggle-switch::after {
      position: absolute !important;
      top: 3px !important;
      left: 3px !important;
      width: 16px !important;
      height: 16px !important;
      background: #fffbf6 !important;
      border-radius: 50% !important;
      content: "" !important;
      transition: transform 0.2s ease !important;
    }

    .cherry-redo-toggle-input:checked + .cherry-redo-toggle-switch {
      background: #241a12 !important;
    }

    .cherry-redo-toggle-input:checked + .cherry-redo-toggle-switch::after {
      transform: translateX(22px) !important;
    }

    .cherry-redo-toggle-input:focus-visible + .cherry-redo-toggle-switch {
      outline: 2px solid #bd2023 !important;
      outline-offset: 2px !important;
    }

    .cherry-redo-toggle-info {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 16px !important;
      height: 16px !important;
      padding: 0 !important;
      color: #fffbf6 !important;
      background: #241a12 !important;
      border: 0 !important;
      border-radius: 50% !important;
      font-family: serif !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      cursor: pointer !important;
      text-decoration: none !important;
    }

    .cherry-redo-toggle-price {
      justify-self: end !important;
      color: #241a12 !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      line-height: 1.5 !important;
      letter-spacing: 0.7px !important;
      white-space: nowrap !important;
    }

    [data-target="checkout-buttons-container"] {
      display: flex !important;
      flex-direction: column !important;
      width: 100% !important;
      margin-top: 0 !important;
      padding: 0 !important;
      gap: 0 !important;
    }

    slot[name="cherry-cart-subtotal"] {
      display: block;
      width: 100%;
    }

    [data-target="coverage-button"],
    [data-target="non-coverage-button"] {
      width: 100% !important;
      height: 50px !important;
      min-height: 50px !important;
      max-height: 50px !important;
      padding: 8px 20px !important;
      background-color: #241a12 !important;
      color: #fffbf6 !important;
      border: 0 !important;
      border-radius: 5px !important;
      font-family: inherit !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      letter-spacing: 0.6px !important;
      text-transform: uppercase !important;
      cursor: pointer !important;
      box-sizing: border-box !important;
      text-decoration: none !important;
      margin: 0 !important;
      transition: opacity 0.2s ease !important;
      align-items: center !important;
      justify-content: center !important;
    }

    [data-target="coverage-button"]:hover,
    [data-target="non-coverage-button"]:hover {
      opacity: 0.88 !important;
    }

    [data-target="coverage-button"] *,
    [data-target="non-coverage-button"] * {
      color: #fffbf6 !important;
      font-family: inherit !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      letter-spacing: 0.6px !important;
      text-transform: uppercase !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    [data-target="coverage-button"] [data-target="subtitle-text-container"],
    [data-target="coverage-button"] [data-target="subtitle-text-container"] * {
      display: none !important;
    }

    /* Single Button Rule: Show only ONE button at a time */
    :host(:not([data-protection-active="false"])) [data-target="coverage-button"] {
      display: flex !important;
    }
    :host(:not([data-protection-active="false"])) [data-target="non-coverage-button"] {
      display: none !important;
    }

    :host([data-protection-active="false"]) [data-target="coverage-button"] {
      display: none !important;
    }
    :host([data-protection-active="false"]) [data-target="non-coverage-button"] {
      display: flex !important;
    }
  `;

  function setupRedoElement(el) {
    if (!el) return;
    const shadow = el.shadowRoot || el._redoShadowRoot;
    if (!shadow) return;

    let isUpdating = false;

    function applyToggle() {
      if (isUpdating) return;
      isUpdating = true;

      try {
        // Ensure our style element is present in the shadow root
        let style = shadow.getElementById('cherry-redo-style');
        if (!style) {
          style = document.createElement('style');
          style.id = 'cherry-redo-style';
          style.textContent = SHADOW_CSS;
          shadow.prepend(style);
        }

        const buttonsContainer = shadow.querySelector('[data-target="checkout-buttons-container"]');
        if (!buttonsContainer) {
          isUpdating = false;
          return;
        }

        // Set initial host attribute based on saved preference
        const currentActive = getSavedPreference();
        if (!el.hasAttribute('data-protection-active')) {
          el.setAttribute('data-protection-active', String(currentActive));
        }

        // Create or get the toggle row
        let toggleRow = shadow.querySelector('[data-cherry-toggle]');
        if (!toggleRow) {
          toggleRow = document.createElement('div');
          toggleRow.className = 'cherry-redo-toggle-row';
          toggleRow.setAttribute('data-cherry-toggle', '');
          toggleRow.innerHTML = `
            <label class="cherry-redo-toggle-label">
              <input type="checkbox" class="cherry-redo-toggle-input">
              <span class="cherry-redo-toggle-switch" aria-hidden="true"></span>
              <span class="cherry-redo-toggle-text">Free returns + package protection</span>
            </label>
            <button type="button" class="cherry-redo-toggle-info" aria-label="More information about coverage" title="Package protection information">i</button>
            <span class="cherry-redo-toggle-price"></span>
          `;

          // Insert right above the buttons container
          buttonsContainer.parentNode.insertBefore(toggleRow, buttonsContainer);

          const input = toggleRow.querySelector('.cherry-redo-toggle-input');
          input.checked = el.getAttribute('data-protection-active') !== 'false';

          input.addEventListener('change', () => {
            const active = input.checked;
            el.setAttribute('data-protection-active', String(active));
            savePreference(active);

            // Sync with any other redo toggle or cart-level checkbox
            syncAllToggles(active);
          });

          const infoBtn = toggleRow.querySelector('.cherry-redo-toggle-info');
          infoBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const originalInfoBtn = shadow.querySelector('[data-target="toggle-info-button"]');
            if (originalInfoBtn) {
              originalInfoBtn.click();
            }
          });
        }

        // Project the live subtotal between coverage and checkout while keeping
        // it in the light DOM for the theme's cart price updates.
        const drawer = el.closest('.cart-drawer');
        const priceHolder = drawer?.querySelector('[data-cart-price-holder]');
        if (priceHolder) {
          let subtotalSlot = shadow.querySelector('slot[name="cherry-cart-subtotal"]');
          if (!subtotalSlot) {
            subtotalSlot = document.createElement('slot');
            subtotalSlot.name = 'cherry-cart-subtotal';
          }
          if (subtotalSlot.nextSibling !== buttonsContainer) {
            buttonsContainer.before(subtotalSlot);
          }
          if (priceHolder.parentNode !== el) {
            const marker = document.createComment('Cart subtotal original position');
            const originalSlot = priceHolder.getAttribute('slot');
            priceHolder.before(marker);
            subtotalPlacements.set(el, { holder: priceHolder, marker, originalSlot });
            priceHolder.slot = 'cherry-cart-subtotal';
            el.appendChild(priceHolder);
          }
        }

        // Keep input checked state in sync with host attribute
        const input = toggleRow.querySelector('.cherry-redo-toggle-input');
        if (input) {
          const shouldBeChecked = el.getAttribute('data-protection-active') !== 'false';
          if (input.checked !== shouldBeChecked) {
            input.checked = shouldBeChecked;
          }
        }

        // Sync price from Redo's price element
        const redoPrice = shadow.querySelector('[data-target="price"]');
        const priceDisplay = toggleRow.querySelector('.cherry-redo-toggle-price');
        if (redoPrice && priceDisplay) {
          const priceText = redoPrice.textContent.trim();
          if (priceText && priceDisplay.textContent !== priceText) {
            priceDisplay.textContent = priceText;
          }
        }
      } finally {
        isUpdating = false;
      }
    }

    applyToggle();

    // Observe shadow root mutations for dynamic price or re-renders by Redo
    if (!el._cherryObserver) {
      const observer = new MutationObserver(() => {
        applyToggle();
      });
      observer.observe(shadow, {
        childList: true,
        subtree: true,
        characterData: true
      });
      el._cherryObserver = observer;
    }
  }

  function syncAllToggles(active) {
    document.querySelectorAll('redo-shopify-toggle').forEach((other) => {
      other.setAttribute('data-protection-active', String(active));
      const otherShadow = other.shadowRoot || other._redoShadowRoot;
      const otherInput = otherShadow?.querySelector('.cherry-redo-toggle-input');
      if (otherInput) otherInput.checked = active;
    });

    // Also sync light DOM checkbox if present
    const lightCheckbox = document.getElementById('cherry-cart-protection');
    if (lightCheckbox && lightCheckbox.checked !== active) {
      lightCheckbox.checked = active;
      lightCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function scanAndInit() {
    restoreDetachedSubtotals();
    document.querySelectorAll('redo-shopify-toggle').forEach((el) => {
      setupRedoElement(el);
    });
  }

  // Listen to the early attachShadow event from head hook
  window.addEventListener('redo:shadow-attached', (e) => {
    if (e.detail?.element) {
      setupRedoElement(e.detail.element);
    }
  });

  // Observe document for dynamically added redo elements
  if (document.body) {
    const docObserver = new MutationObserver((mutations) => {
      restoreDetachedSubtotals();
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.tagName && node.tagName.toLowerCase() === 'redo-shopify-toggle') {
            setupRedoElement(node);
          } else if (node.querySelector) {
            const found = node.querySelector('redo-shopify-toggle');
            if (found) setupRedoElement(found);
          }
        }
      }
    });

    docObserver.observe(document.body, { childList: true, subtree: true });
    scanAndInit();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      const docObserver = new MutationObserver((mutations) => {
        restoreDetachedSubtotals();
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (node.nodeType !== Node.ELEMENT_NODE) continue;
            if (node.tagName && node.tagName.toLowerCase() === 'redo-shopify-toggle') {
              setupRedoElement(node);
            } else if (node.querySelector) {
              const found = node.querySelector('redo-shopify-toggle');
              if (found) setupRedoElement(found);
            }
          }
        }
      });

      docObserver.observe(document.body, { childList: true, subtree: true });
      scanAndInit();
    });
  }

  // Also scan on theme cart events
  ['theme:cart:loaded', 'theme:cart:added', 'cart:updated'].forEach((evt) => {
    document.addEventListener(evt, () => setTimeout(scanAndInit, 100));
  });
})();
